module.exports = ":host{display:flex;flex-direction:column;flex-grow:1}:host .radiobutton h5,:host .checkbox h5{font-size:7px}\n"